import { Box, Stack } from '@mui/material';
import styled from 'styled-components';

export const Paper = styled(Box)`
  && {
    position: relative;
    background-color: ${({ theme }) => theme.palette.background.paper};
    border-radius: ${({ theme }) => theme.shape.cardRadius};
    box-shadow: ${({ theme }) =>
      `inset 0 0 0 1px ${theme.palette.stroke.secondaryLight}`};
  }
`;

export const HeaderPaper = styled(Stack)`
  && {
    flex-direction: row;
    align-items: center;
    position: relative;
    background-color: ${({ theme }) => theme.palette.background.paper};
    padding: 0.5rem 1.5rem;
    border: 1px solid ${({ theme }) => theme.palette.stroke.secondaryLight};
    border-radius: ${({ theme }) => theme.shape.cardRadius};
    min-height: 3.5rem;
  }
`;
